import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import FacebookIcon from '../../icons/FacebookIcon';
import InstagramIcon from '../../icons/InstagramIcon';
import { SocialLink, Wrapper } from './FooterSocialLinks.styles';

const FooterSocialLinks = () => {
  const { t } = useTranslation('common');

  return (
    <Wrapper>
      <SocialLink href={t('footer.links.social.instagram')}>
        <InstagramIcon />
      </SocialLink>
      <SocialLink href={t('footer.links.social.facebook')}>
        <FacebookIcon />
      </SocialLink>
    </Wrapper>
  );
};

export default FooterSocialLinks;
